import React, { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { Dialog } from 'functional-foundations'
import { DialogType } from 'functional-foundations/types'
import { Button, Icon, Typography } from 'foundations-library/components'
import { getValue } from 'firebase-utils'

const jss = () => ({
    dialog: {
        padding: '37px 0 17px 0',
        '& .dialog-container': {
            paddingRight: 30
        }
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        marginBottom: 10
    },
    text: {
        marginBottom: 30
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-around'
    }
})

const useStyles = makeStyles(jss)

/**
 *
 */
const PaymentFailedDialog = ({
    children,
    ...props
}: PropsWithChildren<DialogType>): JSX.Element => {
    const styles = useStyles()

    return <Dialog {...props} width={600} className={styles.dialog}>
        <div className={styles.titleContainer}>
            <Icon name='cancel' size={33} color='destructive-600' data-testid='payment-failed-dialog-icon'/>
            <Typography
                remoteConfigID='sms_registration_payment_failed_dialog_title'
                color='destructive-600'
                variant='h6'
                data-testid='payment-failed-dialog-title'
            />
        </div>
        <Typography
            className={styles.text}
            variant='body1'
            color='neutral-900'
            data-testid='payment-failed-dialog-text'
        >
            { children }
        </Typography>
        <div className={styles.buttonContainer}>
            <Button
                onClick={props.onClose}
                data-testid='payment-failed-dialog-button'
            >
                {getValue('sms_registration_payment_failed_dialog_button_text')}
            </Button>
        </div>
    </Dialog>
}

export default PaymentFailedDialog
